import { SEVERITY } from "helpers/utils.js";
import {
  GET_DEVICE_INFO_NOTIFICATION_HISTORY,
  GET_DEVICE_INFO_NOTIFICATION_HISTORY_SUCCESS,
  GET_DEVICE_INFO_NOTIFICATION_HISTORY_FAIL,
  GET_DEVICE_INFO_NOTIFICATION_HISTORY_BY_ID_SUCCESS,
  ADD_NEW_DEVICE_INFO_NOTIFICATION_HISTORY,
  ADD_NEW_DEVICE_INFO_NOTIFICATION_HISTORY_SUCCESS,
  UPDATE_DEVICE_INFO_NOTIFICATION_HISTORY,
  UPDATE_DEVICE_INFO_NOTIFICATION_HISTORY_SUCCESS,
  DELETE_DEVICE_INFO_NOTIFICATION_HISTORY,
  DELETE_DEVICE_INFO_NOTIFICATION_HISTORY_SUCCESS,
  DEVICE_INFO_NOTIFICATION_HISTORY_CLEAR_NOTIFY,
} from "./actionTypes.js";
const initState = {
  items: [],
  item: null,
  error: null,
  itemCount: 0,
  pageCount: 0,
  loading: false,
  message: null,
};

const deviceInfoNotificationHistory = (state = initState, action) => {
  const { type, payload } = action;
  switch (type) {
    case ADD_NEW_DEVICE_INFO_NOTIFICATION_HISTORY:
    case UPDATE_DEVICE_INFO_NOTIFICATION_HISTORY:
    case DELETE_DEVICE_INFO_NOTIFICATION_HISTORY:
    case GET_DEVICE_INFO_NOTIFICATION_HISTORY:
      return {
        ...state,
        loading: true,
      };
    case GET_DEVICE_INFO_NOTIFICATION_HISTORY_SUCCESS:
      const { itemCount, pageCount, data } = payload;
      return {
        ...state,
        itemCount,
        pageCount,
        items: data,
        loading: false,
      };
    case GET_DEVICE_INFO_NOTIFICATION_HISTORY_BY_ID_SUCCESS:
      return {
        ...state,
        item: payload,
      };

    case ADD_NEW_DEVICE_INFO_NOTIFICATION_HISTORY_SUCCESS:
      return {
        ...state,
        message: {
          title: "Delivery Order",
          text: "Delivery Order has been added successfully.",
          severity: SEVERITY.INFO,
        },
      };
    case UPDATE_DEVICE_INFO_NOTIFICATION_HISTORY_SUCCESS:
      return {
        ...state,
        message: {
          title: "Delivery Order",
          text: "Delivery Order has been updated successfully.",
          severity: SEVERITY.INFO,
        },
      };
    case DELETE_DEVICE_INFO_NOTIFICATION_HISTORY_SUCCESS:
      return {
        ...state,
        message: {
          title: "Delivery Order",
          text: "Delivery Order has been deleted successfully.",
          severity: SEVERITY.INFO,
        },
      };
    case GET_DEVICE_INFO_NOTIFICATION_HISTORY_FAIL:
      return {
        ...state,
        error: payload,
      };
    case DEVICE_INFO_NOTIFICATION_HISTORY_CLEAR_NOTIFY:
      return {
        ...state,
        message: null,
      };
    default:
      return state;
  }
};

export default deviceInfoNotificationHistory;
